// TarifsSection.jsx
import React from "react";

const TarifsSection = ({ name, label, sectionTitle, tarifs, openTarifs, setOpenTarifs }) => {
    const isOpen = openTarifs[name];

    return (
        <>
            <div className="tarifs-section show">
                <h2 className='section-title'>{sectionTitle}</h2>
                <div className="tarifs-grid">
                    {tarifs.map((t, i) => (
                        <div key={i} className="tarif-card">
                            <h3>
                                {t.icon && (
                                    <img 
                                        src={t.icon} 
                                        alt={`Icone ${t.title}`} 
                                        className="tarif-card-icon" 
                                    />
                                )}
                                {t.title}
                            </h3>
                            <p>{t.description}</p>
                            <strong>{t.price}</strong>
                        </div>
                    ))}
                </div>
            </div>
        </>
    );
};

export default TarifsSection;